import React, { useState } from 'react';
import toast from 'react-hot-toast';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';
import authService from '../../../api-authorization/AuthorizeService';

interface IDeleteSprayProfileDialogProps {
  clientId: string;
  sprayProfileId: string;
  sprayProfileName: string;
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

const DeleteSprayProfileDialog: React.FC<IDeleteSprayProfileDialogProps> = ({
  clientId,
  sprayProfileId,
  sprayProfileName,
  open,
  onClose,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);

  const deleteNozzle = async () => {
    setLoading(true);
    const token = await authService.getAccessToken();
    const response = await fetch(
      `${process.env.REACT_APP_BASE_URL}/api/admin/tractors/spray-profile?clientId=${clientId}&sprayProfileId=${sprayProfileId}`,
      {
        method: 'DELETE',
        headers: !token
          ? {}
          : {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
      }
    );
    if (response.ok) {
      toast.success(`${sprayProfileName} deleted successfully`);
      onSuccess();
    } else {
      toast.error(`Failed to delete ${sprayProfileName}'`);
    }
    setLoading(false);
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <DeleteIcon /> Delete Spray Profile
      </DialogTitle>
      <DialogContent>
        Are you sure you want to delete {sprayProfileName} ?
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" disabled={loading} onClick={onClose}>
          Cancel
        </Button>
        <Button variant="outlined" disabled={loading} onClick={deleteNozzle}>
          Delete Spray Profile
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteSprayProfileDialog;
